<script lang="ts" setup>
import { defineProps, defineEmits } from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";

defineProps({
  menuItems: {
    type: Array as () => {
      title: string;
      icon: string;
      active: boolean;
      page: string;
    }[],
    required: true,
  },
});

const emit = defineEmits(["change-menu"]);

const changeMenu = (index: number) => {
  emit("change-menu", index);
};
</script>

<template>
  <div class="main-header--menu-items">
    <div
      v-for="(item, index) in menuItems"
      :key="index"
      class="main-header--menu-item"
      :class="item.active ? 'active' : ''"
      @click="changeMenu(index)"
    >
      <div
        class="main-header--menu-item_icon"
        :class="{ '--active': item.active }"
      >
        <BaseIcon :name="item.icon" />
      </div>
      <div class="main-header--menu-item_title">
        <p class="caption-navbar main-header--menu-item_text">
          {{ item.title }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/colors";

.main-header {
  &--menu-items {
    margin-top: 31px;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    gap: 12px;

    @media (max-width: 960px) {
      position: fixed;
      bottom: 0px;
      width: 100%;
      flex-direction: row;
      left: 0;
      background-color: white;
      height: 93px;
      justify-content: space-evenly;
      padding-top: 12px;
    }
  }

  &--menu-item {
    padding: 7.5px 12px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: background-color 0.4s;
    &_icon {
      color: var(--color-secondary);
      font-size: 24px;
      opacity: 0.2;
      transition: opacity 0.4s;
      &.--active {
        opacity: 1;
      }
    }

    &.active {
      background-color: var(--color-white);
    }

    &_text {
      @media (max-width: 960px) {
        display: none;
      }
    }
  }
}
</style>
